import { Box, Flex, useAppTheme, Text } from '@workwhile/ui'
import React from 'react'
import { SectionHeading } from './SectionHeading'
import { useShiftDetailContextValue } from '../../../context/ShiftDetailProvider'
import { useListingsOverviewContextValue } from '../context/ListingsOverviewProvider'
import { FlexibleInfoTable } from '../../FlexibleInfoTable'
import { AlertTriangle } from 'lucide-react'
import { ListingFunnelPanel } from './ListingFunnelPanel'
import { TierStatsProvider } from '../context/TierStatsProvider'
import { TierInsightsPanel } from './TierInsightsPanel/TierInsightsPanel'

export const ListingsOverviewMain = () => {
  const { colors } = useAppTheme()

  const {
    state: { listingId },
  } = useListingsOverviewContextValue()

  const {
    state: { isFrozen },
  } = useShiftDetailContextValue()

  return (
    <Box>
      <SectionHeading listingId={listingId} />
      {isFrozen ? (
        <Box mb={3}>
          <FlexibleInfoTable
            Icon={AlertTriangle}
            iconColor={colors.errors[200]}
          >
            <Text fontSize={2} maxWidth="100%" color={colors.errors[200]}>
              One or more listings are frozen
            </Text>
            <Text fontSize={2} maxWidth="100%" color={colors.errors[200]}>
              Workers cannot be assigned to this shift
            </Text>
          </FlexibleInfoTable>
        </Box>
      ) : null}
      <TierStatsProvider>
        <Flex gap={3} flexWrap="wrap" alignItems="flex-start" width="100%">
          <TierInsightsPanel />
          <Flex flex={1} minWidth="400px" flexDirection="column">
            {listingId ? <ListingFunnelPanel listingId={listingId} /> : null}
          </Flex>
        </Flex>
      </TierStatsProvider>
    </Box>
  )
}
